import { List } from '@flixbus/honeycomb-react';
import React from 'react';

export type GraphData = {
  displayName: string;
  jobTitle: string;
  mail: string;
  businessPhones: string[];
  officeLocation: string;
};

export const ProfileData: React.FC<{ graphData: GraphData }> = ({ graphData }) => {
  return (
    <List className='profileData'>
      <li>{graphData.displayName}</li>
      <li>{graphData.jobTitle}</li>
      <li>{graphData.mail}</li>
      <li>{graphData.businessPhones[0]}</li>
      <li>{graphData.officeLocation}</li>
    </List>
  );
};
